import {MenuItem, TextField} from '@mui/material'
import {TFunction} from 'i18next'
import React from 'react'

type Props = {
  t: TFunction
  hasEndDate: boolean
  hasEndsAfterRepetitions: boolean
  onChange: (next: EndingOptions) => void
}

export type EndingOptions = 'never' | 'afterCount' | 'onDate'

export const CustomRepetitionEndOptions: React.FC<Props> = ({
  hasEndDate,
  hasEndsAfterRepetitions,
  onChange,
  t
}) => {
  const mode: EndingOptions =
    (hasEndDate && 'onDate') || (hasEndsAfterRepetitions && 'afterCount') || 'never'

  return (
    <TextField
      data-test-id="task-custom-repetition-end-options"
      sx={{width: 100}}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        const next = event.target.value as EndingOptions

        onChange(next)
      }}
      select
      value={mode}
      variant="outlined"
    >
      <MenuItem value={'never'} data-test-id="repetition-ends-never">
        {t('recurringDialog.endsNever')}
      </MenuItem>
      <MenuItem value={'onDate'} data-test-id="repetition-ends-on-date">
        {t('recurringDialog.endsOnDate')}
      </MenuItem>
      <MenuItem value={'afterCount'} data-test-id="repetition-ends-after-count">
        {t('recurringDialog.endsAfterCount')}
      </MenuItem>
    </TextField>
  )
}
